import React, { FC } from 'react';
import { Image } from 'react-native';

import { Theme } from '@constants';

import { ICON_MAP_CURRENT, ICON_MAP_FORECAST } from '../../../assets/icons/icon_map';
import { ICON_PATH_MAP } from '../../../assets/icons/icon_path_map';

type CodeMap = {
  forecast: keyof typeof ICON_MAP_FORECAST;
  current: keyof typeof ICON_MAP_CURRENT;
};

type WeatherType = keyof CodeMap;

type TWCIconProps = {
  code: CodeMap[WeatherType];
  height?: number;
  type?: WeatherType;
  width?: number;
};

export const TWCIcon: FC<TWCIconProps> = ({ code, height = 50, type = 'forecast', width = 50 }) => {
  let iconPath;

  if (type === 'current') {
    iconPath = ICON_PATH_MAP[ICON_MAP_CURRENT[code as CodeMap[typeof type]]];
  } else {
    iconPath = ICON_PATH_MAP[ICON_MAP_FORECAST[code as CodeMap[typeof type]]];
  }

  return (
    <Image
      accessibilityIgnoresInvertColors
      source={iconPath}
      style={{ height: Theme.px(height), width: Theme.px(width) }}
    />
  );
};
